import { SCALER, ScalingParams } from "./client_util"

/** Visible bounds in the stage's coordinates, including the mobile extensions. */
export const stageViewport = () => {
    const inset = ScalingParams.viewportPaddingX * ScalingParams.surfaceZoom
    const insetY = ScalingParams.viewportPaddingY * ScalingParams.surfaceZoom
    return {
        left: -inset, right: 800 + inset, width: 800 + inset * 2, inset,
        top: -insetY, bottom: 600 / SCALER + insetY, height: 600 / SCALER + insetY * 2, insetY,
    }
}

const VIRTUAL_W = 800
const VIRTUAL_H = 600
const DISPLAY_RATIO = VIRTUAL_W / (VIRTUAL_H / SCALER)
const MAX_BUFFER_PIXELS = 5_000_000

/** Keep the existing stage scale, extending the world to fill mobile displays in both axes. */
export const canvasLayout = (width: number, height: number, dpr: number, mobile: boolean) => {
    const wide = width / height >= DISPLAY_RATIO
    const fillWidth = mobile && wide
    const cssWidth = wide && !fillWidth ? height * DISPLAY_RATIO : width
    const cssHeight = mobile || wide ? height : width / DISPLAY_RATIO
    const virtualWidth = fillWidth ? (width / height) * (VIRTUAL_H / SCALER) : VIRTUAL_W
    const virtualHeight = mobile && !wide ? (height / width) * VIRTUAL_W * SCALER : VIRTUAL_H
    const stageX = (virtualWidth - VIRTUAL_W) / 2
    const stageY = (virtualHeight - VIRTUAL_H) / 2
    const maxResolution = Math.sqrt(MAX_BUFFER_PIXELS / (virtualWidth * virtualHeight))

    return {
        cssWidth,
        cssHeight,
        virtualWidth,
        virtualHeight,
        stageX,
        stageY,
        resolution: Math.max(1, Math.min((cssWidth * dpr) / virtualWidth, maxResolution)),
    }
}
